<template>
  <v-tooltip bottom :disabled="missingPermissionsList.length === 0 || disabled">
    <template v-slot:activator="{ on }">
      <div v-on="on" style="width: 100%; height: 100%">
        <slot />
      </div>
    </template>

    <div style="text-align: left">
      <span>{{ $t("MissingPermissions") }}:</span>

      <div v-for="permission in missingPermissionsList" :key="permission">
        <span>
          {{ $t(permission) }}
        </span>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "MissingPermissionsTooltip",

  props: {
    /**
     * list of missing permissions to be able to click the button
     */
    missingPermissionsList: {
      type: Array,
      required: true
    },

    /**
     * Determines if the tooltip is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Atoms/MissingPermissionsTooltip.vue